<div class="app-sidebar-player">
    <div class="titleDiv">
        <h2 class="title" *ngIf="title!=''">{{title}}</h2>
    </div>
    <mat-card-header>
        <mat-card-title>
            <div class="player-title">
                {{(stationDetails && stationDetails.name) ? stationDetails.name : "N/A"}}
                {{ (stationDetails && stationDetails.frequency) ? stationDetails.frequency : "N/A" }}
                {{ (stationDetails && stationDetails.band) ? stationDetails.band : "N/A" }}
                <app-badge-station  *ngIf="(stationDetails)"  [stationId]="stationDetails.id"></app-badge-station>
            </div>
        </mat-card-title>
    </mat-card-header>
    <img [src]="stationLogo" class="station-logo" (error)="setPlaceholderImage()">
    <app-audio-player></app-audio-player>
    <div class="row" style="margin-top: 5px;">  <!-- TODO: remove after prod push -->
        <div class="col-sm-12 p-0" style="text-align: center;">
            <button mat-raised-button (click)="downloadAudio()" *ngIf="hit !== null">
                Download Audio from current time
            </button>
        </div>
    </div>
    <mat-card-content *ngIf="rawTranscription">
        <p class="my-2" [innerHTML]="rawTranscription | stylizedText"></p>
    </mat-card-content>

    <button mat-icon-button class="close-button" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</div>